import { TGCTAs } from "@swiggy-private/cart-types";
import { CTATypes } from "@super-ui/components/swiggy-one-widget-dls-wrapper";
import { checkCtaType } from "./index";

interface CartUpsellCTAs {
    viewAllBenefits?: TGCTAs;
    changePlanCta?: TGCTAs;
    oneTapCta?: TGCTAs;
}

export const findCartUpsellCTAs = (ctas: TGCTAs[]): CartUpsellCTAs => {
    if (!ctas?.length) {
        return {};
    }

    return {
        viewAllBenefits: ctas.find(cta => cta?.type?.includes(CTATypes.BENEFITS_LIST_DEEPLINK)),
        changePlanCta: ctas.find(cta => cta?.type?.includes(CTATypes.CHANGE_PLAN)),
        oneTapCta: ctas.find(cta => checkCtaType(cta.type) || checkCtaType(cta.type, CTATypes.ONE_TAP_REMOVE)),
    };
};
